module.exports = __webpack_public_path__ + "img/indicator.e9d89f9e.svg";